module.exports = __webpack_public_path__ + "img/MEI.c2585712.png";